module.exports = __webpack_public_path__ + "media/images/illustrations/prepworks-academy-7599d41ec14d93d7dfd407785bf6d216.svg";